<template>
  <svg
    width="30"
    height="25"
    viewBox="0 0 40 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.2422 9.90625C39.5469 9.66406 40 9.89062 40 10.2734V26.25C40 28.3203 38.3203 30 36.25 30H3.75C1.67969 30 0 28.3203 0 26.25V10.2812C0 9.89062 0.445312 9.67188 0.757812 9.91406C2.50781 11.2734 4.82812 13 12.7969 18.7891C14.4453 19.9922 17.2266 22.5234 20 22.5078C22.7891 22.5312 25.625 19.9453 27.2109 18.7891C35.1797 13 37.4922 11.2656 39.2422 9.90625ZM20 20C21.8125 20.0312 24.4219 17.7188 25.7344 16.7656C36.1016 9.24219 36.8906 8.58594 39.2812 6.71094C39.7344 6.35937 40 5.8125 40 5.23438V3.75C40 1.67969 38.3203 0 36.25 0H3.75C1.67969 0 0 1.67969 0 3.75V5.23438C0 5.8125 0.265625 6.35156 0.71875 6.71094C3.10938 8.57812 3.89844 9.24219 14.2656 16.7656C15.5781 17.7188 18.1875 20.0312 20 20Z"
      fill="#1E90FF"
    />
  </svg>
</template>
